
class ContratoItemOrigem {
    id: number = 0;
    contratoSap: string = "";
    origem: string = "";
    idItemContrato: number = 0;
  }
  
  export default ContratoItemOrigem;
  